export default function CodeConfirmModal({
  open,
  c,
  inp,
  title,
  message,
  code,
  onCodeChange,
  onConfirm,
  onCancel,
  confirmLabel,
  autoFocus,
  onEnter,
}) {
  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div style={{ background: c.bg, padding: 20, borderRadius: 8, border: `1px solid ${c.border}`, maxWidth: 400, width: "90%" }}>
        <h3 style={{ margin: 0, marginBottom: 10, fontSize: 18 }}>{title}</h3>
        <p style={{ margin: 0, marginBottom: 15, fontSize: 14 }}>{message}</p>
        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          {(() => {
            const isSave = confirmLabel === "Speichern" || confirmLabel === "Erstellen";
            const isDelete = confirmLabel === "Löschen";
            const isDark = c.bg === "#0f1117";
            const confirmStyle = isSave
              ? {
                  background: isDark ? "#0d2d1a" : "#f0fff4",
                  color: isDark ? "#48bb78" : "#276749",
                  border: isDark ? "#48bb78" : "#9ae6b4",
                }
              : isDelete
              ? {
                  background: isDark ? "#3b1010" : "#fee2e2",
                  color: isDark ? "#fecaca" : "#b91c1c",
                  border: isDark ? "#ef4444" : "#fca5a5",
                }
              : {
                  background: "transparent",
                  color: c.textSecondary,
                  border: c.border,
                };
            return (
              <button
                type="button"
                onClick={onConfirm}
                style={{
                  background: confirmStyle.background,
                  color: confirmStyle.color,
                  border: `1px solid ${confirmStyle.border}`,
                  borderRadius: "8px",
                  cursor: "pointer",
                  padding: "6px 12px",
                  fontSize: 12,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 5,
                }}
              >
                {isSave ? <>💾 {confirmLabel}</> : isDelete ? <>🗑️ {confirmLabel}</> : confirmLabel}
              </button>
            );
          })()}
          <button
            type="button"
            onClick={onCancel}
            style={{
              background: c.bgSecondary || "transparent",
              color: c.textSecondary,
              border: `1px solid ${c.border}`,
              borderRadius: "8px",
              cursor: "pointer",
              padding: "6px 12px",
              fontSize: 12,
            }}
          >
            Abbrechen
          </button>
        </div>
      </div>
    </div>
  );
}
